import React from "react"

const FullScreen = ({ children, ...rest }: { children: React.ReactNode; [key: string]: any }) => <main className={"min-w-screen min-h-screen"}>{children}</main>

export default FullScreen
